export default __webpack_public_path__ + "static/media/makeup.a8654aa8.png";